import React from 'react';
import {
  Route,
  Navigate,
  createRoutesFromElements,
  createBrowserRouter,
  RouterProvider
} from 'react-router-dom';
import Layout from './components/Layout';
import GameSetup from './components/GameSetup';
import GameMaster from './components/GameMaster';
import TeamInterface from './components/TeamInterface';

import DemoPage from './DemoPage';
import DemoPageV2 from './DemoPageV2';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<Layout />}>
      <Route path="/starwars" element={<GameSetup />} />
      <Route path="/starwars/demo" element={<DemoPage />} />
      <Route path="/starwars/demo-v2" element={<DemoPageV2 />} />
      <Route path="/starwars/game-master/:gameId" element={<GameMaster />} />
      <Route path="/starwars/team-a/:gameId" element={<TeamInterface team="A" />} />
      <Route path="/starwars/team-b/:gameId" element={<TeamInterface team="B" />} />
      <Route path="*" element={<Navigate to="/starwars" replace />} />
    </Route>
  ),
  {
    basename: '/'
  }
);

const App: React.FC = () => {
  return <RouterProvider router={router} />;
};

export default App;
